var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[(_vm.siteId)?_c('b-container',{staticClass:"p-25",attrs:{"fluid":""}},[_c('addViewSiteDocument',{attrs:{"siteId":_vm.siteId,"isAdmin":_vm.isAdmin}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }